import { createEmptySliceBase, injectTableSlice, toReducer } from '../sliceFactory';

const createSLNOSlice = () => {
  const sliceBase = createEmptySliceBase({ name: 'slnoReports' });
  const withTable = injectTableSlice({ sliceBase });
  return toReducer(withTable);
};

export default createSLNOSlice;
